<template>
    <div class="h-full w-full flex flex-col">
        <SponsorshipOpportunityForm mode="edit" :selected-item="selectedItem" @close="$emit('close')"
            @updated="$emit('updated')" />
    </div>
</template>

<script>
import SponsorshipOpportunityForm from "./form.vue";
export default {
    name: "post-sponsorship-edit",
    emits: ["updated"],
    components: { SponsorshipOpportunityForm, },
    props: ["selectedItem"],
}
</script>